import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';

// Create browser history to use in the Redux store
const baseUrl = (function() {
    const elements = document.getElementsByTagName('base');
    return elements.length === 0 ? '/' : elements[0].getAttribute('href') as string;
})()

export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(history);
